import { colors, media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import styled from 'styled-components';

export const Card = styled.div`
  padding: 30px 20px;
  background: #ffffff;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
  width: auto;
  /* min-width: 350px; */
  overflow: hidden;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 896px;
  margin: auto;
  border-radius: 12px;
  flex-direction: column;
  & > :first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  & > :last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  ${media.md`
    flex-direction: row;

    & > :first-child {
      border-top-right-radius: 0;
      border-bottom-left-radius: 12px;
    }
    & > :last-child {
      border-bottom-left-radius: 0;
      border-top-right-radius: 12px;
    }

  `}
  filter: drop-shadow(0px 20px 50px rgba(0, 0, 0, 0.09));
`;

export const ErrorMessage = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  background: #eee;
  border-radius: 12px;
  width: 276px;
  height: 276px;
  color: ${colors.solid.cinnabar};
  font-size: 16px;
`;
